// frontend/src/components/landing/FeatureGrid.jsx
import { FEATURES_LIST } from "./content";
import "./FeatureGrid.css";

/** Six capabilities in a hairline editorial grid. */
export default function FeatureGrid({ features = FEATURES_LIST }) {
  return (
    <section id="features" className="features section" aria-labelledby="features-title">
      <div className="container">
        <header className="features__head">
          <p className="eyebrow">What&apos;s inside</p>
          <h2 id="features-title" className="section__title">
            Built for prompts
            <br />
            <em>that have to work.</em>
          </h2>
        </header>

        <ul className="features__grid" role="list">
          {features.map((f, i) => (
            <li key={f.title} className="feature">
              <span className="feature__num" aria-hidden="true">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="feature__title">{f.title}</h3>
              <p className="feature__desc">{f.desc}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
